import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';
import Trans from 'next-translate/Trans';
import { useAppContext } from '../../../providers/app-context';

const SEOContent: FunctionComponent<{
  withPart: boolean;
  selection: any;
  stock: string;
  info: any;
}> = ({ withPart, selection, stock, info }) => {
  const { t } = useTranslation();
  const { businessValues } = useAppContext();
  const subCategoryPlural = `parts-and-categories-plural:parts.${selection?.category.category}.${info?.subCategoryEnPart}`;

  return (
    <>
      <div className="w-full bg-blue-10 py-12 lg:py-16 text-justify lg:text-left text-[14px] leading-[24px] max-lg:text-base">
        <div className="container mx-auto px-4 pt-4 flex flex-col gap-2 text-justify">
          {withPart ? (
            <>
              <Trans
                i18nKey={'brands:seo-content.with-part'}
                components={{ p: <p /> }}
                values={{
                  count: stock,
                  oneWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.one.feminine')
                      : t('grammar:pronnouns.one.masculine'),
                  yoursWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.yours.feminine')
                      : t('grammar:pronnouns.yours.masculine'),
                  theWordSingular:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.theSingular.feminine')
                      : t('grammar:pronnouns.theSingular.masculine'),
                  theWord:
                    info?.subCategoryType && info?.subCategoryType === 'F'
                      ? t('grammar:pronnouns.the.feminine')
                      : t('grammar:pronnouns.the.masculine'),
                  part: info?.subCategoryEnPart
                    ? t(
                        subCategoryPlural,
                        {},
                        {
                          fallback: info?.subCategory,
                        }
                      )
                    : info?.subCategory,
                  partSingular: info?.subCategory,
                }}
              />
            </>
          ) : (
            <>
              <Trans
                i18nKey={'brands:seo-content.no-part'}
                components={{ p: <p /> }}
                values={{
                  totalStockAvailable:
                    businessValues.totalStockAvailable.defaultValue,
                }}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SEOContent;
